export function promotionHref (value) {
  const url = String(value || '').trim()
  if (!url || /[\\\s\u0000-\u001f\u007f]/.test(url)) return ''
  if (url.charAt(0) === '/' && url.charAt(1) !== '/') return url
  try {
    const parsed = new URL(url)
    return /^https?:$/.test(parsed.protocol) && parsed.hostname && !parsed.username && !parsed.password ? url : ''
  } catch (error) { return '' }
}

export function promotionNewWindow (item) {
  return item.openNewWindow === true || Number(item.openNewWindow) === 1
}



// WEBPACK FOOTER //
// ./src/utils/promotionLink.js